//@ts-check
import React from 'react';
import { Chip } from '@material-ui/core';

import { useStyles } from '../LaunchProducts.style';
import clsx from 'clsx';

const NavigationChips = ({ items, selected, onSelect }) => {
    const styles = useStyles();
    return (
        <div className={styles.navigationChips}>
            {items.map((item, index) => {
                const classes = clsx({
                    [styles.navigationChip]: true,
                    selected: item === selected,
                });
                return <Chip label={item} key={index} className={classes} onClick={() => onSelect(item)} />;
            })}
        </div>
    );
};

export default NavigationChips;
